export default "__VITE_ASSET__BC$3y760__"